import {Frontend} from "./frontend";

(function () {
    XonBoard.BuildingTypes = {
        list: {

            selectors: {
                building_types_table: $('#building-types-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.building_types_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.building_types_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsFiltered);
                            return json.data;
                        }
                    },
                    columns: [
                        {data: 'name', name: 'building_types.name'},
                        {data: 'description', name: 'building_types.description'},
                        {data: 'status', name: 'building_types.status'},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
